import { useCallback } from 'react';
import { formatCurrency, formatPriceAdjustmentDisplay } from '../../../../utils/formatters';

export const useProductsTableCard = () => {
  // Formatear el descuento para mostrar (%↔Bs equivalentes)
  const formatDiscountDisplay = useCallback(
    (discountType: string, discountValue: number, originalPrice: number) =>
      formatPriceAdjustmentDisplay(discountType, discountValue, originalPrice),
    [],
  );

  // Formatear precio
  const formatPrice = useCallback((price: number) => {
    return formatCurrency(price);
  }, []);

  return {
    formatDiscountDisplay,
    formatPrice,
  };
};
